<template>
    <div class="wrap">
        <en_header></en_header>
        <router-view></router-view>
        <en_footer></en_footer>
    </div>
</template>

<script>
    import en_header from "./en_header"
    import en_footer from "./en_footer"
    export default {
        name: "index",
        components:{
            en_header,
            en_footer
        }
    }
</script>

<style scoped>

</style>
